// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 2H2V6.5H4.00368V8.5H2V11H4.00368V13H2V15.5H4.00368V17.5H2V22H6.5V20.0326H8.5V22H11V20.0326H13V22H15.5V20.0326H17.5V22H22V12H12V2Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-measurement-1-filled')
export default class Measurement1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'measurement-1-filled',
    }
  }
}
